import React from 'react';
import './bookingsChart.css';

const data = [
  { day: 'Sat', value: 320 },
  { day: 'Sun', value: 380 },
  { day: 'Mon', value: 420 },
  { day: 'Tue', value: 390 },
  { day: 'Wed', value: 510 },
  { day: 'Thu', value: 650 },
  { day: 'Fri', value: 740 },
];

const WIDTH = 520;
const HEIGHT = 180;
const PADDING = { top: 16, right: 16, bottom: 32, left: 40 };

function normalize(val, min, max, outMin, outMax) {
  return outMin + ((val - min) / (max - min)) * (outMax - outMin);
}

export default function BookingsChart() {
  const values = data.map(d => d.value);
  const min = 0;
  const max = 800;

  const innerW = WIDTH - PADDING.left - PADDING.right;
  const innerH = HEIGHT - PADDING.top - PADDING.bottom;

  const points = data.map((d, i) => ({
    x: PADDING.left + (i / (data.length - 1)) * innerW,
    y: PADDING.top + innerH - normalize(d.value, min, max, 0, innerH),
  }));

  const pathD = points.reduce((acc, p, i) => {
    if (i === 0) return `M${p.x},${p.y}`;
    const prev = points[i - 1];
    const cpX = (prev.x + p.x) / 2;
    return `${acc} C${cpX},${prev.y} ${cpX},${p.y} ${p.x},${p.y}`;
  }, '');

  const areaD = `${pathD} L${points[points.length - 1].x},${PADDING.top + innerH} L${points[0].x},${PADDING.top + innerH} Z`;

  const yTicks = [0, 200, 400, 600, 800];

  return (
    <div className="chart-card">
      <div className="chart-header">
        <span className="chart-title">Weekly Bookings</span>
        <div className="chart-legend">
          <span className="chart-legend-dot" />
          <span>Bookings</span>
        </div>
      </div>
      <svg
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        className="chart-svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <linearGradient id="chartGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#AD4D34" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#AD4D34" stopOpacity="0.01" />
          </linearGradient>
        </defs>

        {/* Grid lines */}
        {yTicks.map(tick => {
          const y = PADDING.top + innerH - normalize(tick, min, max, 0, innerH);
          return (
            <g key={tick}>
              <line
                x1={PADDING.left}
                y1={y}
                x2={WIDTH - PADDING.right}
                y2={y}
                stroke="#EDE8D4"
                strokeWidth="1"
                strokeDasharray="4 3"
              />
              <text
                x={PADDING.left - 8}
                y={y + 4}
                textAnchor="end"
                fontSize="10"
                fill="#9CA3AF"
                fontFamily="Outfit, sans-serif"
              >
                {tick}
              </text>
            </g>
          );
        })}

        {/* Area fill */}
        <path d={areaD} fill="url(#chartGradient)" />

        {/* Line */}
        <path d={pathD} fill="none" stroke="#AD4D34" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />

        {/* Dots */}
        {points.map((p, i) => (
          <circle key={i} cx={p.x} cy={p.y} r="4" fill="#AD4D34" stroke="white" strokeWidth="2" />
        ))}

        {/* X labels */}
        {data.map((d, i) => (
          <text
            key={d.day}
            x={points[i].x}
            y={HEIGHT - 6}
            textAnchor="middle"
            fontSize="10"
            fill="#9CA3AF"
            fontFamily="Outfit, sans-serif"
          >
            {d.day}
          </text>
        ))}
      </svg>
    </div>
  );
}